import { useState } from 'react'
import { Link, useRouterState } from '@tanstack/react-router'
import { Users, History, Search } from 'lucide-react'
import { MatchSearchModal } from '#/components/ui/MatchSearchModal'

export function BottomNav() {
  const router = useRouterState()
  const pathname = router.location.pathname

  const isNewMatch = pathname === '/' || pathname === '/match/new'
  const isTeams = pathname === '/teams'
  const isHistory = pathname === '/history'
  const [showSearchModal, setShowSearchModal] = useState(false)

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-[var(--theme-card-bg,#ffffff)] border-t border-[var(--theme-border,#e5e7eb)] py-1.5 px-4 flex items-center justify-around z-40 select-none shadow-[0_-2px_10px_rgba(0,0,0,0.05)] transition-colors">
        {/* New Match Tab */}
        <Link
          to="/"
          className={`flex flex-col items-center gap-1 transition-colors ${
            isNewMatch ? 'text-[var(--color-cricket-primary,#2E7D32)]' : 'text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          <svg
            className="size-6 stroke-[2]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {/* Cricket batsman stick figure */}
            <circle cx="12" cy="4" r="2" fill="currentColor" />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 7v6m0 0l-3 5m3-5l3 5m-5-8l4-2 3 4"
            />
          </svg>
          <span className="text-xs font-semibold">New Match</span>
        </Link>

        {/* Search Match Tab */}
        <button
          type="button"
          onClick={() => setShowSearchModal(true)}
          className="flex flex-col items-center gap-1 text-gray-400 hover:text-[var(--color-cricket-primary)] dark:text-gray-400 dark:hover:text-gray-200 transition-colors cursor-pointer"
        >
          <Search className="size-6" />
          <span className="text-xs font-semibold">Watch</span>
        </button>

        {/* Teams Tab */}
        <Link
          to="/teams"
          className={`flex flex-col items-center gap-1 transition-colors ${
            isTeams ? 'text-[var(--color-cricket-primary,#2E7D32)]' : 'text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          <Users className="size-6" />
          <span className="text-xs font-semibold">Teams</span>
        </Link>

        {/* History Tab */}
        <Link
          to="/history"
          className={`flex flex-col items-center gap-1 transition-colors ${
            isHistory ? 'text-[var(--color-cricket-primary,#2E7D32)]' : 'text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
        >
          <History className="size-6" />
          <span className="text-xs font-semibold">History</span>
        </Link>
      </nav>

      {/* Match ID search modal */}
      <MatchSearchModal
        isOpen={showSearchModal}
        onClose={() => setShowSearchModal(false)}
      />
    </>
  )
}
